import * as React from 'react';

/**
 * @deprecated Use the MUI SVG icon instead! See https://github.com/tocktix/admin/wiki/Svg-Icons-Components for details.
 **/
const SvgIconTagBag = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width={18} height={16} fill="none" {...props}>
    <path
      clipRule="evenodd"
      d="M.563 7.062a3 3 0 0 1 3-3h10.874a3 3 0 0 1 3 3v5.25a3 3 0 0 1-3 3H3.563a3 3 0 0 1-3-3v-5.25z"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M5.063 4.062v11.25M12.938 4.062v11.25M11.813 4.062v-2.25c0-.622-.504-1.125-1.126-1.125H7.313c-.622 0-1.125.503-1.125 1.125v2.25"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default SvgIconTagBag;
